import { render, staticRenderFns } from "./BreadthRibbonFeedback.vue?vue&type=template&id=34416364&"
import script from "./BreadthRibbonFeedback.vue?vue&type=script&lang=js&"
export * from "./BreadthRibbonFeedback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports